import { render, staticRenderFns } from "./CollectionTypeForm.vue?vue&type=template&id=5298463c&"
import script from "./CollectionTypeForm.vue?vue&type=script&lang=js&"
export * from "./CollectionTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports